
import gql from 'graphql-tag'
export default gql`
    query ViLabelsByFilm ($from: Date, $to: Date, $noCache: Boolean, $filmID: ID, $limit: Int, $offset: Int) {
      ViLabelsByFilm (from: $from, to: $to, noCache: $noCache, filmID: $filmID, limit: $limit, offset: $offset) {
        filmID
        filmName
        masterCount
        labelCount
        durationSum
      }
    }
  `